import useMedias from './useMedias';

export interface MediaVars<T> {
  isDesktopL?: T;
  isDesktopM?: T;
  isDesktop?: T;
  isMobileL?: T;
  isMobileM?: T;
  isMobile: T;
}

function useMediaVar<T>(vars: MediaVars<T>): T {
  const medias = useMedias();
  const [firstKey] = Object.entries(medias)
    .filter(([key]) => !['isOnlyMobile', 'isOnlyDesktop'].includes(key))
    .reverse()
    .find(([, value]) => value);

  return vars[firstKey] || vars.isMobile;
}

export default useMediaVar;
